import { LoginDataSchema, StudentServerResponseSchema, StudentType } from "../types/User";
import { DailyStatusServerResponse, FolderServerResponseSchema, FolderType } from "../types/CounselorData";
import { LessonServerResponse, LessonType } from "../types/Lesson";
import { ZodError } from "zod";
import { ServerResponse } from "../types/General";
import { BannerServerResponseSchema, BannerServerResponseType } from '../types/Banner';
import { ISOStringWithTimeZone } from '../helpers/DateAndTimeHelpers';
import { AxiosInstance } from "axios";

export async function login(axios: AxiosInstance, _phone: string, _password: string) {
    let response = null;
    let data = null;
    try {
        response = await axios.post('login', {phoneNumber: _phone, password: _password});
        console.log(response);
        data = LoginDataSchema.parse(response.data);
        // axios.defaults.headers.post['Authorization'] = 'Bearer' + data.token;
        return data;
    } catch (e: unknown) {
        console.log(e)

        if (e instanceof ZodError)
            return {error: 'مشکلی پیش آمده دوباره تلاش کنید'};
        else
            return {error: 'نام کاربری یا رمز عبور اشتباه است'};
    }
}

export async function fetchStudents(axios: AxiosInstance, counselorId: number, setter: React.Dispatch<React.SetStateAction<StudentType[] | null | undefined>>) {
    try {
        const response = await axios.get('v2/counselor/' + counselorId + '/students');
        const processedData = await StudentServerResponseSchema.parseAsync((response as ServerResponse).data);
        setter(processedData);
    } catch (e) {
        console.error("Error fetching students:", e);
        setter(undefined);
    }
}

export async function fetchFolders(axios: AxiosInstance, counselorId: number, setter: React.Dispatch<React.SetStateAction<FolderType[] | null | undefined>>) {
    try {
        const response = await axios.get('v2/counselor/' + counselorId + '/groups');
        const processedData = await FolderServerResponseSchema.parseAsync((((response as ServerResponse).data) as ServerResponse).data);
        setter(processedData);
    } catch (e) {
        console.error("Error fetching folders:", e);
        setter(undefined); // Set to undefined on error
    }
}

export async function fetchLessons(axios: AxiosInstance, setter: React.Dispatch<React.SetStateAction<LessonType[]>>) {
    const response = await axios.get('lessons');
    LessonServerResponse.parseAsync(response.data.data)
        .then((processedData) => setter(processedData))
        .catch((e) => console.log(e))
}

export async function fetchDailyStatus(axios: AxiosInstance, students: StudentType[], day: string) {
    const ids = [] as number[];
    students.forEach((student) => ids.push(student.id));

    let stringified = JSON.stringify(ids);
    stringified = stringified.substring(1, stringified.length - 1);

    const result = (await axios.get('v2/counselor/status?student_ids=' + stringified + '&day=' + day)) as ServerResponse;
        
    try {
        const parsedData = DailyStatusServerResponse.parse(result.data);
        return parsedData;
    } catch (e) {
        return []
    }
}

export async function fetchBanners(axios: AxiosInstance, setter: React.Dispatch<React.SetStateAction<BannerServerResponseType>>) {
    axios.get('v2/banners')
        .then((res) => {
            const processedData = BannerServerResponseSchema.parse((((res as ServerResponse).data) as ServerResponse).data);
            setter(processedData);
        })
}

export function shouldUpdateWakingTime() {
    const localData = window.localStorage.getItem("wakingTime");

    const currentWakingTime = typeof localData === 'string' 
            ? ISOStringWithTimeZone(new Date(localData || '')) 
            : ISOStringWithTimeZone();

    const now = ISOStringWithTimeZone();
    const time = new Date().getHours();

    if ((now > currentWakingTime || !localData) && (time >= 6 && time <= 7)) {
        return true;
    } else {
        return false;
    }
}
